/**
 * WizardStepper — horizontal stepper for the 6-phase optimization workflow.
 * Phases: Upload → Verify → Settings → Optimize → Review → Approve
 */

import React from 'react';
import '../styles/WizardStepper.css';

export default function WizardStepper({ steps, currentStep, completedSteps, onStepClick }) {
  return (
    <div className="ro-wz-stepper">
      {steps.map((step, i) => {
        const isActive = step.key === currentStep;
        const isComplete = completedSteps.includes(step.key);
        const isAccessible = isComplete || isActive || (i === 0) ||
          completedSteps.includes(steps[i - 1]?.key);

        return (
          <React.Fragment key={step.key}>
            {i > 0 && (
              <div className={`ro-wz-connector ${isComplete || isActive ? 'ro-wz-connector-done' : ''}`} />
            )}
            <button
              className={
                `ro-wz-step` +
                (isActive ? ' ro-wz-step-active' : '') +
                (isComplete && !isActive ? ' ro-wz-step-complete' : '') +
                (!isAccessible ? ' ro-wz-step-locked' : '')
              }
              onClick={() => isAccessible && onStepClick(step.key)}
              disabled={!isAccessible}
              title={!isAccessible ? 'Complete previous steps first' : step.label}
              aria-current={isActive ? 'step' : undefined}
              aria-label={`Step ${i + 1}: ${step.label}${isComplete ? ' (completed)' : ''}${isActive ? ' (current)' : ''}`}
            >
              <span className="ro-wz-num">
                {isComplete && !isActive ? '\u2713' : i + 1}
              </span>
              <span className="ro-wz-label">{step.label}</span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
